import SkeletonBase from "newui/components/Skeleton";
import { RFX_SUBMISSION_STATUS } from "../../constants";
import { getRfxSubmissionStatusPresentation } from "../../utils/rfx-submission-status-colour";
import { RfxSubmissionStatus } from "../../types/submission.type";
import { HStack } from "@chakra-ui/react";
import { Icon } from "assets/Icon";
import { formattedSimpleDate } from "utils/dateFormat";

interface RfxSubmissionStatusPillProps {
	className?: string;
	size?: "p-2" | "p-3" | "p-4";
	submissionDate?: any;
	submissionStatus: RfxSubmissionStatus;
}

export const RfxSubmissionStatusPill: React.FC<
	RfxSubmissionStatusPillProps
> = ({ className, submissionDate, size, submissionStatus }) => {
	if (!submissionStatus) {
		return <SkeletonBase />;
	}

	const status = getRfxSubmissionStatusPresentation(submissionStatus);

	if (!status) {
		return <SkeletonBase />;
	}

	const dateDisplay = (
		<div className="mt-1 block text-xs">
			<HStack>
				<Icon
					icon="calendar"
					color="#0031DD"
					class="aling-middle -mt-[2px] mr-1 inline-block w-[12px]"
				/>
				<div>
					{status.type !== RFX_SUBMISSION_STATUS.SUBMITTED && (
						<>
							Submitted <br />
						</>
					)}
					{formattedSimpleDate(submissionDate)}
				</div>
			</HStack>
		</div>
	);

	return (
		<div>
			<div
				className={`${className} ${size !== undefined ? size : "p-3"} flex items-center justify-center rounded-full bg-white text-center font-roboto text-[14px] font-medium shadow-sm`}
				style={{
					width: "fit-content",
					color: status.color,
					border: `solid 1.5px ${status.colorBorder}`,
					height: "24px",
				}}
			>
				{status.displayText}
			</div>
			{submissionDate && dateDisplay}
		</div>
	);
};
